/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Updated_SuccessInputs */

const en_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue updated successfully`)
};

const fr_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident mis a jour avec succes`)
};

const de_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem erfolgreich aktualisiert`)
};

const it_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema aggiornato con successo`)
};

const ru_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема успешно обновлена.`)
};

const es_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema actualizado exitosamente`)
};

const zh_cn2_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题已成功更新`)
};

const ja_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題が正常に更新されました`)
};

const hi_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या सफलतापूर्वक अपडेट हो गई`)
};

const pt_pt2_manual_qc_updated_success = /** @type {(inputs: Manual_Qc_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema resolvido com sucesso`)
};

/**
* | output |
* | --- |
* | "Issue updated successfully" |
*
* @param {Manual_Qc_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_updated_success = /** @type {((inputs?: Manual_Qc_Updated_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Updated_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_updated_success(inputs)
	if (locale === "de") return de_manual_qc_updated_success(inputs)
	if (locale === "it") return it_manual_qc_updated_success(inputs)
	if (locale === "ru") return ru_manual_qc_updated_success(inputs)
	if (locale === "es") return es_manual_qc_updated_success(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_updated_success(inputs)
	if (locale === "ja") return ja_manual_qc_updated_success(inputs)
	if (locale === "hi") return hi_manual_qc_updated_success(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_updated_success(inputs)
	return en_manual_qc_updated_success(inputs)
});